// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3JrgW","buttons":"Footer_buttons__2TxbQ"};